
import Vue from 'vue'
import { apiService } from '../../service/api.service'

export default Vue.extend({
  name: 'ProductKeyActivation',
  data () {
    return {
      status: null as any,
      statusLoading: false,
      productKey: '',
      activating: false,
      errorMsg: '',
      successMsg: '',
      successSnack: false
    }
  },
  computed: {
    statusCardClass (): string {
      if (!this.status) return 'pk-status-card--saas'
      return 'pk-status-card--onpremise'
    },
    statusIcon (): string {
      if (!this.status) return 'mdi-cloud-outline'
      return 'mdi-shield-check'
    },
    statusIconColor (): string {
      if (!this.status) return 'grey'
      return 'success'
    },
    statusTitle (): string {
      if (this.statusLoading) return 'Loading…'
      if (!this.status) return 'SaaS Mode'
      return 'On-Premise Mode'
    },
    statusSubtitle (): string {
      if (this.statusLoading) return ''
      if (!this.status) return 'No product key activated. Licence creation is unrestricted.'
      const avail = this.status.max_total_devices - this.status.active_devices
      return `${avail} device slot(s) available`
    }
  },
  mounted () {
    this.fetchStatus()
  },
  methods: {
    async fetchStatus () {
      this.statusLoading = true
      try {
        const { data } = await apiService.get('product-key/status')
        this.status = data.mode === 'onpremise' ? data : null
      } catch {
        this.status = null
      } finally {
        this.statusLoading = false
      }
    },
    async activate () {
      this.errorMsg = ''
      this.activating = true
      try {
        const { data } = await apiService.post('product-key/activate', {
          product_key: this.productKey.replace(/\s+/g, '')
        })
        this.successMsg = data.message
        this.successSnack = true
        this.productKey = ''
        await this.fetchStatus()
      } catch (err: any) {
        const msg = err?.response?.data?.message
        this.errorMsg = msg || 'Activation failed. Please check your product key.'
      } finally {
        this.activating = false
      }
    },
    formatDate (iso: string): string {
      if (!iso) return ''
      return new Date(iso).toLocaleDateString('en-GB', {
        day: '2-digit', month: 'short', year: 'numeric'
      })
    }
  }
})
